import { createFileRoute } from "@tanstack/react-router";

import PostDetail from "@/pages/post/PostDetail";

function PostDetailPage() {
  const { caseId } = Route.useParams();
  return <PostDetail caseId={caseId} />;
}

export const Route = createFileRoute("/post/$caseId")({
  component: PostDetailPage,
});
